import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Button from "../Components/Button";
import liaison_brochure from "../images/brochures/liaison_brochure.pdf"


function Milestones() {

    const params = useParams();
    const path = params.micro_id;


    let [show, setShow] = useState(false);

    useEffect(() => {
        if (path === "dtcp" || path === "landuse" || path === "layoutapproval" || path === "hacanoc") {
            setShow(true);
        }
        else {
            setShow(false);
        }
    }, [])


    const milestoneCard = [
        {
            milestone_number: "40+",
            milestone_heading: "Liaison",
            milestone_content: "Services",
        },
        {
            milestone_number: "1000+ ",
            milestone_heading: "Acres",
            milestone_content: "Land use Change",
        },
        {
            milestone_number: "5 Million",
            milestone_heading: "Sqft",
            milestone_content: "Building Approval",
        },
        {
            milestone_number: "500+",
            milestone_heading: "Acres",
            milestone_content: "Land aggregation",
        },
    ]
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <>

            {/* Milestones */}
            <section className="bg-[#363537] text-white font-alibaba mt-[60px] px-4 py-[40px] sm:py-[80px]">

                <section className={show === true ? "max-w-[1010px] mx-auto text-center !text-white mt-[40px] mb-[120px] px-4" : "hidden"}>
                    <h1 className='heading !font-noto !text-white'>Comprehensive Liaison & Legal Services</h1>
                    <p className="max-w-[809px] mx-auto text-[18px] leading-[28px] mt-[30px]">Discover the power of personalised guidance in property and real estate liaison. With 15 years of process experience and an expert team of dedicated liaison officers, Lands and Lands provides unparalleled industry support for real estate liaising</p>
                </section>


                <div className="max-w-[1120px] mx-auto px-2 sm:flex flex-wrap justify-between">
                    {
                        milestoneCard.map((items) => {
                            return (
                                <div className="w-[232px] mx-auto text-center mt-20 sm:mt-6 lg:mt-0 md:mx-0">
                                    <h2 className="text-yellow text-[40px] font-semibold leading-[45px] max-w-[236px]" data-aos="fade-up">{items.milestone_number}</h2>
                                    <h2 className="text-yellow text-[40px] font-semibold leading-[45px] max-w-[236px]" data-aos="fade-up">{items.milestone_heading}</h2>
                                    <hr className="w-full border-[0.50px] border-[#EECA01] my-[25px]" data-aos="fade-up"/>
                                    <h3 className="text-[20px]" data-aos="fade-up">{items.milestone_content}</h3>
                                </div>

                            );
                        })}
                </div>

                <div className='flex justify-center mt-[100px] mb-[20px]'>
                    <Button
                        name={"Download Brochure"}
                        design={"filled"}
                        action={"download"}
                        sourceFile={liaison_brochure}
                    />
                </div>

            </section>
        </>
    );
}

export default Milestones;